import { IGetPropertiesDTO, PropertyType } from '@/models/property.model';
import { TPropertyFiltersValues, PropertyFiltersFields } from '../helpers/types';
import { StepType } from '@/models/step.model';

class GetPropertiesDTO implements IGetPropertiesDTO {
  address?: string;
  cursor?: string;
  step_name?: StepType;
  property_type?: PropertyType[];
  user_email?: string;
  user_phone_number?: string;
  total_orders_sum_gte?: string;
  user_name?: string;
  established?: string;
  steps_completed?: string[];
  valuation_price_gte?: number;
  sold_price_gte?: number;
  limit?: number;

  constructor(values: TPropertyFiltersValues) {
    this.address = values[PropertyFiltersFields.ADDRESS];
    this.user_email = values[PropertyFiltersFields.EMAIL];
    this.user_phone_number = values[PropertyFiltersFields.PHONE_NUMBER];
    this.total_orders_sum_gte = values[PropertyFiltersFields.ORDERS_SUM];
    this.user_name = values[PropertyFiltersFields.OWNERS];
    this.steps_completed = values[PropertyFiltersFields.PROGRESS];
    this.property_type = values[PropertyFiltersFields.TYPE] as PropertyType[];
    this.cursor = values[PropertyFiltersFields.CURSOR];
    this.established = values[PropertyFiltersFields.ESTABLISHED];
    this.valuation_price_gte = values[PropertyFiltersFields.VALUATION_PRICE]
      ? Number(values[PropertyFiltersFields.VALUATION_PRICE])
      : undefined;
    this.sold_price_gte = values[PropertyFiltersFields.SOLD_PRICE]
      ? Number(values[PropertyFiltersFields.SOLD_PRICE])
      : undefined;
  }
}

export default GetPropertiesDTO;
